import { getBackgroundCSS, getBorderCSS, getColorsCSS, getMultiShadowCSS, getSeparatorCSS, getSpaceCSS, getTypoCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { members = [], columnGap, rowGap, layout, textAlign, padding, photoWidth, photoMargin, nameTypo, nameMargin, titleTypo, titleMargin, sepMargin, bioTypo, bioMargin, socialSize, socialIconMargin } = attributes;

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${getTypoCSS(nameTypo)?.googleFontLink ? `@import url(${getTypoCSS(nameTypo)?.googleFontLink});` : ''}
			${getTypoCSS(titleTypo)?.googleFontLink ? `@import url(${getTypoCSS(titleTypo)?.googleFontLink});` : ''}
			${getTypoCSS(bioTypo)?.googleFontLink ? `@import url(${getTypoCSS(bioTypo)?.googleFontLink});` : ''}

			#tsbTeamMembers-${clientId} .tsbTeamMembers{
				grid-gap: ${rowGap} ${columnGap};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember{
				text-align: ${textAlign};
				padding: ${getSpaceCSS(padding)};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberPhoto{
				width: ${photoWidth};
				margin: ${'horizontal' === layout ? '0 20px 0 0' : `${getSpaceCSS(photoMargin)}`};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberName{
				${getTypoCSS(nameTypo)?.styles}
				margin: ${getSpaceCSS(nameMargin)};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberTitle{
				${getTypoCSS(titleTypo)?.styles}
				margin: ${getSpaceCSS(titleMargin)};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSeparator{
				margin: ${getSpaceCSS(sepMargin)};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberBio{
				${getTypoCSS(bioTypo)?.styles}
				margin: ${getSpaceCSS(bioMargin)};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .icon,
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .memberSocialAdd{
				margin: ${getSpaceCSS(socialIconMargin)};
			}
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .icon i,
			#tsbTeamMembers-${clientId} .tsbTeamMembers .tsbMember .memberDetails .memberSocial .memberSocialAdd i{
				font-size: ${socialSize};
				width: ${socialSize};
			}
			`.replace(/\s+/g, ' ')
		}} />

		{members.map((member, index) => {
			const { background, border, shadow, photoBorder, nameColor, titleColor, separator, bioColor, socialIconColors } = member;

			return <style key={index} dangerouslySetInnerHTML={{
				__html: `
				#tsbTeamMembers-${clientId} #tsbMember-${index}{
					${getBackgroundCSS(background)}
					${getBorderCSS(border)}
					box-shadow: ${getMultiShadowCSS(shadow)};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberPhoto{
					${getBorderCSS(photoBorder)}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberName{
					color: ${nameColor};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberTitle{
					color: ${titleColor};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberSeparator{
					${getSeparatorCSS(separator)}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberBio{
					color: ${bioColor};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial{
					justify-content: ${'center' === textAlign ? 'center' : 'right' === textAlign ? 'flex-end' : 'flex-start'}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial li a{
					${getColorsCSS(socialIconColors)}
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial li.isSelected{
					border: 2px solid ${socialIconColors?.bg};
				}
				#tsbTeamMembers-${clientId} #tsbMember-${index} .memberDetails .memberSocial li.memberSocialAdd button i{
					color: ${socialIconColors?.bg};
				}
				`.replace(/\s+/g, ' ')
			}} />;
		})}
	</>;
}
export default Style;